<!-- 群活码详情 -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="群活码详情">
    </el-page-header>
    <div class="containerC">
      <div class="container-t">
        <el-descriptions title="基本信息" :column="1">
          <el-descriptions-item label="群活码名称">{{
            groupData.name
          }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{
            groupData.author
          }}</el-descriptions-item>
             <el-descriptions-item label="客户数">{{
            groupData.total_count
          }}</el-descriptions-item>
          <el-descriptions-item label="客户群活码">
            <div class="content">
              <el-image
                style="width: 12.8rem; height: 12.8rem"
                :src="groupData.code_image"
                :preview-src-list="[groupData.code_image]"
                fit="scale-down"
              ></el-image>
            </div>
            <div class="head">
              <el-button type="text">
                <a
                  :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${groupData.code_image}&usertoken=${tooken.usertoken}`"
                  style="color: #317AF8"
                  :download="`渠道活码`"
                  >下载活码</a
                >
              </el-button>
              <el-button style="margin-left: .6rem;color: #317AF8" type="text" @click="copyText"
                >复制链接</el-button
              >
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="container-b">
        <div class="content-b-title">客户群活码明细</div>
        <el-table
          :data="groupData.group_chatArray"
          style="margin-top: 2rem"
          border
          
          
        >
          <el-table-column prop="title" label="活码名称" width="300">
          </el-table-column>
          <el-table-column prop="url" label="活码图片" width="200">
            <template slot-scope="scope">
              <el-image
                style="width: 7rem; height: 7rem"
                :src="scope.row.url"
                :preview-src-list="[scope.row.url]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="group_name" label="群名称" width="800">
            <template slot-scope="scope">
              <div>
                <el-tag
                  
                  effect="plain"
                  style="margin-right: .6rem"
                  v-for="i in scope.row.group_name"
                  :key="i"
                  >{{ i }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
            <el-table-column prop="count" label="客户数" width="120">
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="170">
            <template slot-scope="scope">
              <el-button type="text" size="mini">
                <a
                  :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${scope.row.url}&usertoken=${tooken.usertoken}`"
                  style="color: #317AF8  !important" 
                  :download="`群活码`"
                  >下载</a
                >
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "customerCodeDetail",
  data() {
    return {
      groupData: {},
    };
  },

  components: {},

  computed: {},

  mounted() {
    if (this.$route.query.id) {
      this.getData();
    }
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/GroupLiveCodeTwo/LiveCodesListOne",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
        }),
      });
      if (res.code == 1) {
        this.groupData = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    copyText() {
      const content = this.groupData.code_image;
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute("value", `${content}`);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功");
      }
      document.body.removeChild(input);
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  margin-top: -.6rem;
}
.content-b-title {
  margin-top: 4rem;
  font-size: 1.6rem;
  font-weight: 700;
  color: #303133;
}
.containerC{
  background-color: #ffffff;
  border-radius: .8rem;
  padding: 4rem 2rem;
}

</style>